import styled from 'styled-components';
import {
  AiOutlineArrowLeft,
  AiOutlineArrowRight,
  AiOutlinePlusCircle,
  AiOutlineMinusCircle,
  AiFillCaretDown,
  AiOutlineClose,
} from 'react-icons/ai';
import { BsArrowBarLeft } from 'react-icons/bs';
import { FaSort } from 'react-icons/fa';
import { RiLockPasswordLine } from 'react-icons/ri';
import { GrCheckbox, GrCheckboxSelected } from 'react-icons/gr';

export const DownArrow = props => {
  return (
    <BtnWrapper>
      <AiFillCaretDown {...props} />
    </BtnWrapper>
  );
};

export const LeftArrow = props => {
  return (
    <BtnWrapper>
      <AiOutlineArrowLeft {...props} />
    </BtnWrapper>
  );
};

export const RightArrow = props => {
  return (
    <BtnWrapper>
      <AiOutlineArrowRight {...props} />
    </BtnWrapper>
  );
};

export const SortArrow = props => {
  return (
    <BtnWrapper>
      <FaSort {...props} />
    </BtnWrapper>
  );
};

export const BackArrow = props => {
  return (
    <BtnWrapper>
      <BsArrowBarLeft {...props} />
    </BtnWrapper>
  );
};

export const CreateBtn = props => {
  return (
    <BtnWrapper>
      <AiOutlinePlusCircle {...props} />
    </BtnWrapper>
  );
};

export const DeleteBtn = props => {
  return (
    <BtnWrapper>
      <AiOutlineMinusCircle {...props} />
    </BtnWrapper>
  );
};

export const CloseBtn = props => {
  return (
    <BtnWrapper>
      <AiOutlineClose {...props} />
    </BtnWrapper>
  );
};

export const PasswordLock = props => {
  return <RiLockPasswordLine {...props} />;
};

export const CheckBox = props => {
  return <GrCheckbox {...props} />;
};

export const CheckBoxSelected = props => {
  return <GrCheckboxSelected {...props} />;
};

const BtnWrapper = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;
